import { useState, useMemo } from 'react';
import moment from 'moment';

import { user } from 'services';
import { deleteSubscription } from 'services/payments-service';
import { TableExt, TableInfo, Confirm, themes, GridBox, GridUpdateMessage, GridColumnsSetup } from 'libs/ui';
import { useGridColumns } from 'libs/hooks';
import SubscriptionForm from './forms/subscription-form';
import { ExtensionForm } from './forms/extension-form';
import { getTableParams } from './grid.params';

import { useTranslation } from 'react-i18next';

export const SubscriptionGrid = (props) => {
  const { count, entries, className, theme, getXlsAction, updateEntry } = props;

  const { t } = useTranslation();

  const [showForm, setShowForm] = useState('');
  const [message, setMessage] = useState('');
  const [row, setRow] = useState({});
  const [confirm, setConfirm] = useState(null);

  /**
   * close confirm
   */
  const closeConfirm = () => {
    setConfirm(null);
  };

  /**
   * delete item
   */
  const delItem = (id) => {
    const test = false;
    if (test) {
      console.log('del ' + id);
      return;
    }
    deleteSubscription(id).then(() => {
      props.getEntries({ offset: 0 }, null, true);
      closeConfirm();
    });
  };

  // actions
  const addItemAction = () => {
    setRow({});
    setShowForm('addForm');
  };

  const editItemAction = (row) => {
    setRow(row);
    setShowForm('editForm');
  };

  const activateItemAction = (row) => {
    setRow(row);
    setShowForm('extForm');
  };

  const delItemAction = (row) => {
    setRow(row);
    setConfirm({
      title: t('messages.СО') + ' ' + row.mean_id + ' ' + t('messages.будет удалено. Продолжить?'),
      width: '440px',
      type: 'danger',
      cancelButton: { text: t('buttons.Отмена'), func: closeConfirm },
      acceptButton: { text: t('buttons.Удалить'), func: () => delItem(row.id), theme: themes.red },
    });
  };

  /**
   * close form
   * @returns
   */
  const closeForm = () => setShowForm('');

  /**
   * close ext form
   * @param {*} success
   */
  const closeExtensionForm = (success = false) => {
    closeForm();
    if (success) {
      setMessage(t('messages.Абонемент активирован'));
      setTimeout(() => setMessage(''), 3000);
    }
  };

  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  // actions
  const rightEdit = user.haveRight('subscriptions.update');
  const rightDel = user.haveRight('subscriptions.delete');
  const rightAdd = user.haveRight('subscriptions.add');
  const actions = [];
  if (rightEdit) {
    actions.push({ title: t('buttons.Активировать'), action: activateItemAction, isVisible: (row) => !row.is_blocked });
    // actions.push({ title: 'Редактировать', action: editItemAction });
  }
  if (rightDel) {
    actions.push({ title: t('buttons.Удалить'), action: delItemAction });
  }

  // top actions
  const topActions = [];
  if (rightAdd) {
    topActions.push({
      title: t('buttons.Добавить'),
      icon: 'fa-plus',
      theme: themes.blue,
      action: addItemAction,
    });
  }
  if (count) {
    getXlsAction(topActions);
  }

  // const d1 = moment().endOf('day').subtract(1, 'days');
  const initial =
    showForm === 'addForm'
      ? {
          start_at: moment().add(-1, 'day').format('YYYY-MM-DD 00:00'),
          end_at: moment().add(-1, 'day').format('YYYY-MM-DD 23:59:59'),
          qrtoken: false,
        }
      : { ...row };

  const tableParams = useMemo(() => getTableParams(t), []);
  const { getFields, fields: staticFields, ...restTableParams } = tableParams;
  const defaultFields = useMemo(() => (getFields ? getFields(props) : staticFields), [getFields, staticFields, props]);
  const { fields, columns, toggleColumn, reorderColumns, resetColumns } = useGridColumns('subscription', defaultFields);
  topActions.push({ cmp: <GridColumnsSetup key="columns-setup" columns={columns} onToggle={toggleColumn} onReorder={reorderColumns} onReset={resetColumns} /> });

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} actions={topActions} />

      <TableExt
        theme={theme}
        title={t('sections.Абонемент')}
        rows={{ count, items }}
        actions={actions}
        className={className}
        refresh={props.refresh}
        clientId={props.clientId}
        onRowClick={rightEdit ? editItemAction : undefined}
        {...restTableParams}
        fields={fields}
        updateEntry={updateEntry}
      />

      {confirm && <Confirm {...confirm} />}

      {showForm && showForm !== 'extForm' && (
        <SubscriptionForm
          type={showForm}
          close={closeForm}
          //id={props.id}
          clientId={props.clientId}
          id={row.id}
          time_limit_balance={row.time_limit_balance ?? null}
          pending_time_limit_balance={row.pending_time_limit_balance ?? null}
          meanId={row.mean_id}
          meanType={row.mean_type}
          setMessage={setMessage}
          refresh={props.refresh}
          tariffs={props.tariffs}
          initialValues={initial}
        />
      )}

      {showForm === 'extForm' && <ExtensionForm refresh={props.refresh} id={row.id} mean_id={row.mean_id} close={(result) => closeExtensionForm(result)} />}

      {message && <GridUpdateMessage>{message}</GridUpdateMessage>}
    </GridBox>
  );
};
